export let fillcompile = (data) => {
  // 變數宣告
  var NewPayCategory = ''
  let p = null
  let a1 = null
  let b1 = null
  let num2 = null
  const num1 = data
  const currnum = 128

  // num1 二進位轉換
  if (num1 >= currnum) {
    num2 = '1'; a1 = num1 - currnum; b1 = currnum / 2
  } else {
    num2 = '0'; a1 = num1; b1 = currnum / 2
  }
  for (p = 1; p <= 7; p++) {
    if (a1 >= b1) {
      num2 = num2 + '1'; a1 = a1 - b1; b1 = b1 / 2
    } else {
      num2 = num2 + '0'; b1 = b1 / 2
    }
  }

  // 切割num2字串
  let Bit7Reserved = num2.slice(0, 1)
  let Bit6Reserved = num2.slice(1, 2)
  let Bit5BillWithoutBarcode = num2.slice(2, 3)
  let Bit4BillWithBarcode = num2.slice(3, 4)
  let Bit3LINE = num2.slice(4, 5)
  let Bit2iPASS = num2.slice(5, 6)
  let Bit1CreditOutside = num2.slice(6, 7)
  let Bit0CreditInside = num2.slice(7, 8)

  // 判斷0,1寫入繳款選項
  if (Bit0CreditInside === '1') { Bit0CreditInside = '國內信用卡/' } else { Bit0CreditInside = '' }
  if (Bit1CreditOutside === '1') { Bit1CreditOutside = '國外信用卡/' } else { Bit1CreditOutside = '' }
  if (Bit2iPASS === '1') { Bit2iPASS = '一卡通/' } else { Bit2iPASS = '' }
  if (Bit3LINE === '1') { Bit3LINE = 'Line Pay/' } else { Bit3LINE = '' }
  if (Bit4BillWithBarcode === '1') { Bit4BillWithBarcode = '繳費單(含超商條碼)/' } else { Bit4BillWithBarcode = '' }
  if (Bit5BillWithoutBarcode === '1') { Bit5BillWithoutBarcode = '繳費單(無超商條碼)' } else { Bit5BillWithoutBarcode = '' }
  if (Bit6Reserved) { Bit6Reserved = '' }
  if (Bit7Reserved) { Bit7Reserved = '' }
  NewPayCategory = Bit0CreditInside + Bit1CreditOutside + Bit2iPASS + Bit3LINE + Bit4BillWithBarcode + Bit5BillWithoutBarcode + Bit6Reserved + Bit7Reserved

  return NewPayCategory
}
